import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-186b5704"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-animation tw-relative tw-h-full tw-bg-white tw-rounded tw-border tw-border-1 tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]" }
const _hoisted_2 = {
  id: "dash-cyber-health-assessment-title",
  class: "tw-h-[66px] tw-rounded-t tw-flex tw-justify-between tw-items-center tw-bg-[#FCFCFD] tw-py-[25px] tw-px-[20px] tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_3 = { class: "tw-flex tw-gap-[10px]" }
const _hoisted_4 = { class: "tw-text-[#211F58] tw-text-[18px] tw-font-semibold" }
const _hoisted_5 = {
  key: 0,
  class: "tw-text-[#211F58] tw-text-[18px]"
}
const _hoisted_6 = {
  key: 0,
  class: "custom-global-skeleton tw-p-[20px] tw-h-[182px]"
}
const _hoisted_7 = { class: "tw-flex tw-gap-[20px] tw-flex-wrap" }
const _hoisted_8 = { class: "tw-flex tw-flex-col tw-grow tw-gap-[6px] tw-justify-between" }
const _hoisted_9 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_10 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-[500] tw-leading-[130%] title" }
const _hoisted_11 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_12 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_13 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
}
const _hoisted_14 = {
  key: 1,
  class: "tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]"
}
const _hoisted_15 = { class: "tw-text-[#878787] tw-font-[500]" }
const _hoisted_16 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_17 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_18 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_19 = { class: "tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]" }
const _hoisted_20 = { class: "tw-text-[#878787] tw-font-[500]" }
const _hoisted_21 = { class: "tw-flex tw-grow tw-gap-[20px] tw-flex-wrap" }
const _hoisted_22 = { class: "tw-flex tw-flex-col tw-grow tw-gap-[6px] tw-justify-between" }
const _hoisted_23 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_24 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[135%] title" }
const _hoisted_25 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_26 = {
  key: 0,
  class: "default tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-[#878787]"
}
const _hoisted_27 = {
  key: 1,
  class: "default tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-[#878787]"
}
const _hoisted_28 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_29 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_30 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_31 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-[400]" }
const _hoisted_32 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_33 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_34 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_35 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-[400]" }
const _hoisted_36 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass([
              'tw-flex tw-items-center tw-justify-center tw-bg-[#ffffff] tw-w-[72px] tw-h-[72px]',
            ])
}
const _hoisted_37 = {
  key: 0,
  class: "tw-mt-[20px] tw-px-[20px] tw-py-[15px] tw-bg-[#D9EDE2] tw-rounded-md tw-flex tw-justify-between tw-items-center"
}
const _hoisted_38 = { class: "tw-flex tw-items-center tw-gap-[12px]" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/bulb_icon.svg",
  alt: "bulb",
  class: "tw-w-[18px] tw-h-[18px] icon",
  style: {}
}, null, -1))
const _hoisted_40 = { class: "tw-text-[13px] tw-font-[400]" }

import { Ref, computed, onMounted, ref, watch } from "vue";
import store from "@/store";
import { getComponentUiText, getShortChecklistName } from "@/utils/utilities";
import {
  IChecklistInfoDetail,
  IChecklistMetrics,
  IChecklistMetricsCompletion,
} from "@/interfaces/assessments/IAssessmentDetails";
import AssessmentChecklistStatusTag from "../assessment/assessmentChecklistStatusTag.vue";
import RadialProgressBar from "../prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import {
  generateCheklistStatusIdToChecklistStatusName,
  generateGradeScoreWithCompletedScore,
  getCheckListIdMetricsCompletion,
  getDetailFromCheckListId,
  TEXT_COLOR_WITH_GRADE_SCORE,
} from "@/services/assessment";
import { assessmentStatus, CHECKLISTSTATUS } from "@/utils/constants";
import {
  convertUTCTimeToLocalTime,
  getTimeFromNow,
} from "@/utils/dateTimeUtils";
import router from "@/router";
import { checklistStatusId } from "@/utils/constants";
import { showErrorAPI } from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";
import DummyCard from "./dummyCard.vue";
import get from "lodash/get";


export default /*#__PURE__*/_defineComponent({
  __name: 'cyberHealthAssessment',
  props: {
  loadingChecklist: {
    type: Boolean,
    default: true,
    required: false,
  },
  checklistId: {
    type: String,
    required: true,
  },
  metric: {
    type: Object as () => IChecklistMetrics,
    required: true,
  },
},
  emits: ["button:click"],
  setup(__props, { emit: emits }) {

const props = __props;



const isLoading = ref(false);
const checklistCompletion: Ref<IChecklistMetrics> = ref(
  {} as IChecklistMetrics,
);

const latestChecklistDetail = computed(() => {
  const cl = store.getters["Recommend/getChecklistDetailById"](
    props.checklistId,
  );
  return cl || {};
});
const checklistLastUpdatedDate = ref("");

const percentScore = computed(() => {
  const score = checklistCompletion.value?.checklistScorePcnt;
  return (score * 100).toFixed(2);
});

const isShowRadial = computed(() => {
  return (
    latestChecklistDetail.value?.checklistStatusId !== CHECKLISTSTATUS.DONE
  );
});



const dummyData = ref({
  checklistStatusName: "Checklist Status",
  checklistStatus: "Created",
  checklistStatusId: "new",
  checklistCompletion: 0,
  checklistCompletionMax: 955,
  checklistScore: 0,
  checklistScoreMax: 0,
  checklistScorePcnt: 0,
  checklistDateCreated: "",
  checklistDateEdited: "",
});

const isShowDummy = computed(() => {
  return (
    (!Object.keys(latestChecklistDetail.value).length || !props.checklistId) &&
    !isLoading.value
  );
});

onMounted(async () => {
  if (props.checklistId) {
    isLoading.value = true;
    await getDataStatusCard();
    await getChecklistDetails();
    isLoading.value = false;
  }
});

watch(
  () => props.checklistId,
  async (value: any) => {
    isLoading.value = true;
    if (value) {
      await getDataStatusCard();
      await getChecklistDetails();
    }
    isLoading.value = false;
  },
);

watch(
  () => props.metric,
  (newValue) => {
    checklistCompletion.value = newValue;
  },
);

const getDataStatusCard = async () => {
  try {
    const res = await getCheckListIdMetricsCompletion(props.checklistId);
    const data = get(res, "data.data", {}) as IChecklistMetricsCompletion;
    checklistMetricsCompletion.value = data;
  } catch (error: any) {
    showErrorAPI(error, Checklist.getChecklistToItemMetric);
  }
};

const getChecklistDetails = async () => {
  try {
    const res = await getDetailFromCheckListId(Number(props.checklistId));
    const data = get(res, "data.data", {}) as IChecklistInfoDetail;
    checklistLastUpdatedDate.value = data.checklistLastUpdatedDate;
  } catch (error: any) {
    showErrorAPI(error, Checklist.getChecklistToItemMetric);
  }
};

const checklistMetricsCompletion: Ref<IChecklistMetricsCompletion> = ref(
  {} as IChecklistMetricsCompletion,
);

const percentProgress = computed(() => {
  return parseFloat(
    (checklistMetricsCompletion.value.checklistCompletionPcnt * 100).toFixed(2),
  );
});

const isChecklistMetricsCompletionLoading = computed(() => {
  return Object.keys(checklistMetricsCompletion.value).length === 0;
});

const getLastUpdatedTimeFromNow = () => {
  if (!checklistLastUpdatedDate.value) return "-";
  return getTimeFromNow(checklistLastUpdatedDate.value);
};

const getCurrentTime = () => {
  if (!latestChecklistDetail.value.checklistDateCreated) return "-";
  return convertUTCTimeToLocalTime(
    latestChecklistDetail.value.checklistDateCreated,
    undefined,
    "HH:mm",
  );
};

const goToContinueAssessment = () => {
  const query = { checklistId: checklistMetricsCompletion.value.checklistId };
  router.push({ path: "/assess/input", query });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)("app-dashboard-cyber-health-assessment-title-1")), 1),
        (!isShowDummy.value && latestChecklistDetail.value.checklistDateCreated)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " – " + _toDisplayString(_unref(convertUTCTimeToLocalTime)(
              latestChecklistDetail.value.checklistDateReporting
                ? latestChecklistDetail.value.checklistDateReporting
                : latestChecklistDetail.value.checklistDateCreated,
            )), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (isLoading.value || __props.loadingChecklist)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(`tw-p-[20px] ${isShowDummy.value ? 'tw-h-[182px]' : ''}`)
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(getComponentUiText)("app-component-assessment-title-status-1")), 1),
                _createVNode(AssessmentChecklistStatusTag, {
                  "checklist-status": 
                isShowDummy.value
                  ? dummyData.value.checklistStatus
                  : latestChecklistDetail.value.checklistStatus
              ,
                  "checklist-status-id": 
                isShowDummy.value
                  ? dummyData.value.checklistStatusId
                  : latestChecklistDetail.value.checklistStatusId
              ,
                  "is-loading": false
                }, null, 8, ["checklist-status", "checklist-status-id"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(getComponentUiText)("app-component-assessment-title-progress-1")), 1),
                (isChecklistMetricsCompletionLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createTextVNode(_toDisplayString(checklistMetricsCompletion.value.checklistCompletion) + "/" + _toDisplayString(checklistMetricsCompletion.value.checklistCompletionMax) + " ", 1),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(percentProgress.value) + "%", 1)
                    ]))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessments-question-type-2-icon-tooltip-score-1",
                )), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createTextVNode(_toDisplayString(Math.round(+checklistCompletion.value?.checklistScore)) + "/" + _toDisplayString(Math.round(+checklistCompletion.value?.checklistScoreMax)) + " ", 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString((checklistCompletion.value?.checklistScorePcnt * 100).toFixed(1)) + "%", 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(getComponentUiText)(
                    "app-dashboard-cyber-health-assessment-title-template-1",
                  )), 1),
                  _createElementVNode("div", _hoisted_25, [
                    (
                    isShowDummy.value
                      ? true
                      : latestChecklistDetail.value?.templates.length > 0 &&
                        latestChecklistDetail.value?.templates[0]
                          ?.checklistTemplateName
                  )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(latestChecklistDetail.value?.templates?.length > 0
                      ? _unref(getShortChecklistName)(
                          latestChecklistDetail.value?.templates[0]
                            ?.checklistTemplateName,
                        )
                      : _unref(getComponentUiText)(
                          "app-component-assessments-checklists-assessment-template-tag-1",
                        )), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(getComponentUiText)(
                      "app-component-assessments-checklists-assessment-template-tag-1",
                    )), 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(latestChecklistDetail.value.checklistStatusId !==
                  _unref(checklistStatusId).completed
                    ? _unref(getComponentUiText)(
                        "app-component-assessments-checklists-assessment-details-card-label-2",
                      )
                    : _unref(getComponentUiText)(
                        "app-component-assessments-checklists-assessment-details-card-label-3",
                      )), 1),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(getLastUpdatedTimeFromNow()), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(getComponentUiText)("app-dashboard-assessment-status-title-1")), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(getCurrentTime()), 1)
                  ])
                ])
              ]),
              (!isShowRadial.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["tw-w-[72px] tw-h-[72px] tw-flex tw-items-center tw-justify-center tw-text-[30px] tw-font-[600]", `tw-text-[${
                _unref(TEXT_COLOR_WITH_GRADE_SCORE)[
                  _unref(generateGradeScoreWithCompletedScore)(Number(percentScore.value))
                ]
              }]`])
                    }, _toDisplayString(_unref(generateGradeScoreWithCompletedScore)(Number(percentScore.value))), 3)
                  ]))
                : (_openBlock(), _createBlock(RadialProgressBar, {
                    key: 1,
                    class: "d-inline",
                    "total-steps": 100,
                    "completed-steps": isShowDummy.value ? 60 : percentProgress.value,
                    "is-hide-progress": true,
                    "outer-stroke-color": "#48A0FF"
                  }, null, 8, ["completed-steps"]))
            ])
          ]),
          (
          !(
            latestChecklistDetail.value.checklistStatusId ===
              _unref(checklistStatusId).defunct || percentProgress.value === 100
          ) ||
          latestChecklistDetail.value.checklistStatusId ===
            _unref(checklistStatusId).completed
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, _toDisplayString(latestChecklistDetail.value.checklistStatusId ===
              _unref(checklistStatusId).completed
                ? _unref(getComponentUiText)(
                    "app-dashboard-cyber-health-assessment-description-tooltip-2",
                  )
                : _unref(getComponentUiText)(
                    "app-dashboard-cyber-health-assessment-description-tooltip-1",
                  )), 1)
                ]),
                _createElementVNode("div", {
                  class: "tw-cursor-pointer tw-px-[16px] tw-py-[5px] tw-rounded-[26.909px] tw-bg-white tw-flex tw-items-center tw-text-[#387DFF] tw-text-[11px] tw-font-medium",
                  onClick: goToContinueAssessment
                }, _toDisplayString(latestChecklistDetail.value.checklistStatusId ===
            _unref(checklistStatusId).completed
              ? _unref(getComponentUiText)(
                  "app-component-assessment-detail-dropdown-option-view-assessment-title-1",
                )
              : _unref(getComponentUiText)(
                  "app-dashboard-cyber-health-assessment-btn-description-tooltip-1",
                )), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2)),
    (isShowDummy.value && !__props.loadingChecklist)
      ? (_openBlock(), _createBlock(DummyCard, {
          key: 2,
          title: 
        _unref(getComponentUiText)('app-dashboard-dummy-title-cyber-health-score-1')
      ,
          "title-button": 
        _unref(getComponentUiText)('app-assessment-button-create-button-2')
      ,
          "title-class": 'tw-w-[276px]',
          "onButton:click": _cache[0] || (_cache[0] = () => emits('button:click'))
        }, null, 8, ["title", "title-button"]))
      : _createCommentVNode("", true)
  ]))
}
}

})